import React from 'react'
import './SectionSubtitle.css'

const SectionSubtitle = ({ subtitle }) => <p className="section_subtitle">{subtitle}</p>

export default SectionSubtitle
